import toastService from '@/services/toastService'

export default function loyaltySystemModule() {
  /**
   * Вычисляем скидку
   * @param amount
   * @param percent
   * @returns {number}
   */
  const discount = (amount, percent) => Math.floor(amount / 100 * percent)

  /**
   * Переводим баллы в проценты для дальнейшего вычисления
   * @param orderTotalAmount
   * @param numberPointsToPay
   * @param userPoints
   * @returns {number}
   */
  const getPercentPoints = (orderTotalAmount, numberPointsToPay, userPoints) => {
    const maxApplyPoints = orderTotalAmount / 100 * numberPointsToPay
    return maxApplyPoints > userPoints ? userPoints / orderTotalAmount * 100 : maxApplyPoints / orderTotalAmount * 100
  }

  /**
   * Применяем баллы
   * @param basicAmountSeat - стоимость места
   * @param orderTotalAmount - стоимость заказа
   * @param numberPointsToPay - количество баллов для оплаты
   * @param userPoints - количество балов у пользователя
   * @returns {number}
   */
  const applyDiscountPoints = (basicAmountSeat, orderTotalAmount, numberPointsToPay, userPoints) => {
    const percentPoints = getPercentPoints(orderTotalAmount, numberPointsToPay, userPoints)
    return basicAmountSeat - discount(basicAmountSeat, percentPoints)
  }

  /**
   * Применяем льготу
   * @param basicAmountSeat
   * @param percent
   * @returns {number}
   */
  const applyDiscountBeneficiary = (basicAmountSeat, percent) => basicAmountSeat - discount(basicAmountSeat, percent)

  /**
   * Вычисляем скидку для промокодов
   * @param type
   * @param basicAmountSeat
   * @param units
   * @returns {number}
   */
  const discountPromoCodes = (type, basicAmountSeat, units) => {
    let result
    switch (type) {
      case 'percent': result = discount(basicAmountSeat, units); break
      case 'sum': result = units; break
      case 'fixed': result = basicAmountSeat - units; break
      default: result = 0; break
    }
    return result
  }

  /**
   * Применяем промокод
   * @param type
   * @param basicAmountSeat
   * @param units
   * @returns {number}
   */
  const applyDiscountPromoCodes = (type, basicAmountSeat, units) => basicAmountSeat - discountPromoCodes(type, basicAmountSeat, units)

  /**
   * Проверяем, что количество мест больше количества льгот
   * @param numberBenefits
   * @param countSeats
   * @returns {boolean}
   */
  const thereAreMoreSeatsThanBenefitsCheck = (countSeats, numberBenefits) => {
    if (numberBenefits < 1) return false
    return countSeats > numberBenefits
  }

  /**
   * Проверяем, что количество мест больше количества льгот
   * @param numberBenefits
   * @param countSeats
   * @returns {boolean}
   */
  const thereAreMoreSeatsThanBenefits = (countSeats, numberBenefits) => {
    if (thereAreMoreSeatsThanBenefitsCheck(countSeats, numberBenefits)) {
      toastService.error(`Количество мест должно быть меньше или равно ${numberBenefits}`)
      return true
    }
    return false
  }

  const isTypeBenefits = type => type === 'beneficiary'

  /**
   * Проверяем, что клиент выбран
   * @param order
   * @returns {boolean}
   */
  const clientNotFound = order => {
    if (!order.client_id) {
      toastService.error('Операция отклонена, для продолжения нужно выбрать клиента!')
      return true
    }
    return false
  }

  return {
    discount,
    getPercentPoints,
    applyDiscountPoints,
    applyDiscountBeneficiary,
    discountPromoCodes,
    applyDiscountPromoCodes,
    thereAreMoreSeatsThanBenefits,
    thereAreMoreSeatsThanBenefitsCheck,
    clientNotFound,
    isTypeBenefits,
  }
}
